<div class="d-flex gap-3 mt-2 chart-legend">
  <span><i class="legend-mark legend-counted"></i>{{ 'ATTENDANCE_LBL_COUNTED' | translate }}</span>
  <span><i class="legend-mark legend-uncounted"></i>{{ 'ATTENDANCE_LBL_UNCOUNTED' | translate }}</span>
  <span><i class="legend-mark legend-other"></i>{{ 'ATTENDANCE_LBL_OTHER' | translate }}</span>
  <span><i class="legend-mark legend-schedule"></i>{{ 'ATTENDANCE_LBL_WORK_SCHEDULE' | translate }}</span>
  <span><i class="legend-mark legend-ping"></i>{{ 'ATTENDANCE_LBL_PRESENCE_POINT' | translate }}</span>
  @if (this.showFormerEmployee) {
    <span class="legend-former">{{ 'ATTENDANCE_LBL_FORMER_EMPLOYEE' | translate }}</span>
  }
</div>
